import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CardSaldos from "../element/CardSaldos";
import CardPlanesPago from "../element/CardPlanesPago";
import CarAlumnoDatos from "../element/CarAlumnoDatos";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
// import dataContext from "../context/User";

// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from '../componentes/Footer';

import "../css/styleAdmin.css";

const AlumnosSaldo = () => {
  const history = useHistory();

  // const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  datos = JSON.parse(datos);

  if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1 ) {
      history.push("/");
    }
  }  

  const [saldos, setSaldos] = useState({});
  const [carnet, setCarnet] = useState({});
  const [alumno, setAlumno] = useState({});
  const [saldosPP, setSaldosPP] = useState({});
  const [cargando, setCargando] = useState(false);

  let onSutmit = (e) => {
    e.preventDefault();
    localStorage.setItem('currentCarnet', carnet);
    setCargando(true);
    GetFetch.saldosAlumno(carnet, datos.token).then((saldosData) => {
      document.getElementById("dataContenedorAlumno").style.display = "block";
      document.getElementById("contenedorSaldos").style.display = "block";
      setSaldos(saldosData);
      AlumnoDatos();
      setCargando(false);
    }).catch(() => setCargando(false));

    GetFetch.saldosPlanesPagoAlumno(carnet, datos.token).then(
      (saldosDataPP) => {
        setSaldosPP(saldosDataPP);
      }
    );
  };

  let carnetSet = (e) => {
    setCarnet(e.target.value);
  };

  let AlumnoDatos = () => {
    let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
    datosAlum.then((data) => {
      if (data[0]) {
        setAlumno(data[0]);
      }
    });
  };

  useEffect(() => {
    let currentCarnet = localStorage.getItem('currentCarnet');
    if (currentCarnet) {
        setCarnet(currentCarnet);
    }else{
        setCarnet('');
    }
    loadMenu();
    document.getElementById("textCarnet").focus();
  }, []);

  const listaSaldos = saldos.length > 0 ? saldos : [];
  const listaPP = saldosPP.length > 0 ? saldosPP : [];
  const totalSaldo = listaSaldos.reduce((total, element) => total + element.saldo, 0);
  const totalSaldoPP = listaPP.reduce((total, element) => total + element.monto, 0);

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Saldos por alumno</h2>

        <div className="card mb-4">
          <div className="card-body">
            <form id="formUP" onSubmit={onSutmit}>
              <div className="form-group">
                <label htmlFor="textCarnet">Carnet del alumno</label>
                <input
                  id="textCarnet"
                  type="text"
                  placeholder="Carnet"
                  className="form-control"
                  onChange={carnetSet}
                  value={carnet}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                Buscar
              </button>
            </form>
          </div>
        </div>

        <CarAlumnoDatos alumno={alumno} />

        {cargando ? <SkeletonCard rows={4} /> : null}

        {!cargando && saldos.length === undefined ? (
          <EmptyState icon="fa-search" title="Busca un alumno por carnet">
            Ingresa el carnet del alumno y presiona Buscar para consultar sus saldos pendientes.
          </EmptyState>
        ) : null}

        <div id="contenedorSaldos" style={{ display: "none" }}>
          <div className="esen-stat-grid">
            <div className="esen-stat esen-stat--hero">
              <div>
                <div className="esen-stat-value">${totalSaldo.toFixed(2)}</div>
                <div className="esen-stat-label">Total de saldo pendiente</div>
              </div>
            </div>
            {listaPP.length > 0 ? (
              <div className="esen-stat">
                <div>
                  <div className="esen-stat-value">${totalSaldoPP.toFixed(2)}</div>
                  <div className="esen-stat-label">Total planes de pago</div>
                </div>
              </div>
            ) : null}
          </div>

          {listaPP.length > 0 ? (
            <div className="card">
              <div className="card-header">
                <i className="fa fa-credit-card-alt mr-2" aria-hidden="true"></i>
                Cuotas pendientes de planes de pago
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Cuota</th>
                        <th scope="col">Monto</th>
                        <th scope="col">Vencimiento</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaPP.map((element, i) => (
                        <CardPlanesPago
                          key={i}
                          cuota={element.cuota}
                          monto={element.monto}
                          vencimiento={element.vencimiento}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          ) : null}

          <div className="card">
            <div className="card-header">
              <i className="fa fa-money mr-2" aria-hidden="true"></i>
              Meses pendientes de pago
            </div>
            <div className="card-body">
              {listaSaldos.length > 0 ? (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th scope="col">Concepto</th>
                        <th scope="col" className="text-right">Saldo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaSaldos.map((element, i) => (
                        <CardSaldos
                          key={i}
                          factura={element.factura}
                          concepto={element.concepto}
                          saldo={element.saldo}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted mb-0">El alumno no tiene saldos mensuales activos.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlumnosSaldo;
